import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=2a0bc6d7&scoped=true"
import script from "./Remark.vue?vue&type=script&lang=js"
export * from "./Remark.vue?vue&type=script&lang=js"
import style0 from "./Remark.vue?vue&type=style&index=0&id=2a0bc6d7&prod&lang=scss&scoped=true"
import style1 from "./Remark.vue?vue&type=style&index=1&id=2a0bc6d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0bc6d7",
  null
  
)

export default component.exports